<template>
  <grille-pack-card-item />
  <!-- <pack-card-item /> -->
</template>

<script>
import GrillePackCardItem from './GrillePackCardItem.vue'
export default {
  
  components: { GrillePackCardItem },
 
}
</script>

<style></style>